import { render, staticRenderFns } from "./stuKns.vue?vue&type=template&id=6de31b5d&scoped=true"
import script from "./stuKns.vue?vue&type=script&lang=js"
export * from "./stuKns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de31b5d",
  null
  
)

export default component.exports